module.exports = __webpack_public_path__ + "img/cdbecd6.png";